module.exports = __webpack_public_path__ + "static/media/rapun-extended.88cbeec9.mp4";